import SuccessSVG from '@assets/Success.svg?react';
import { Button } from '@imprivata-cloud/design-system';
import { DONE_AUTO_CONTINUE_MS } from '@selfservice/utils/helpers';
import { useTranslation } from 'react-i18next';
import './EnrollmentCompletedCard.less';

interface EnrollmentCompletedCardProps {
  onDone: () => void;
}

/**
 * Face-enrollment acknowledgement. The Done button fills over
 * `DONE_AUTO_CONTINUE_MS` and then advances on its own, so the dwell before the
 * flow returns to the launching product is visible rather than silent. Clicking
 * cancels the fill and advances immediately.
 */
export const EnrollmentCompletedCard = ({ onDone }: EnrollmentCompletedCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="root-enrollment-completed">
      <div className="content">
        <div className="success-svg">
          <SuccessSVG />
        </div>
        <h2 className="enroll-title">
          {t('self-service.enroll.completed.title', { authMethod: 'face' })}
        </h2>
      </div>
      <div className="enroll-buttons">
        <Button
          aria-label="continue-button"
          variant="primary"
          fullWidth
          progressDurationMs={DONE_AUTO_CONTINUE_MS}
          onProgressComplete={onDone}
          onClick={onDone}
        >
          {t('common.done-button')}
        </Button>
      </div>
    </div>
  );
};
